import React, { useState } from 'react';
import PathsForm from './paths_form';
import styles from '../../app.module.css'

const PathsSection = ({
    paths,
    addPath,
    editPath,
    removePath,
    existingTags = [],
    existingParameters = [],
    existingResponses = [],
    existingRequestBody = [],
    existingSecuritySchemes = [],
}) => {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [currentPath, setCurrentPath] = useState(null);

    const handleAddPath = () => {
        setCurrentPath(null); 
        setIsFormVisible(true);
    };

    const handleEditPath = (pathName) => {
        const sanitizedOperations = Object.entries(paths[pathName] || {}).map(([verb, operation]) => {
            const sanitizedOperation = {
                ...operation,
                responses: Object.entries(operation.responses || {}).map(([httpStatus, response]) => ({
                    httpStatus,
                    response: typeof response.$ref === 'string'
                        ? response.$ref.replace('#/components/responses/', '')
                        : '', 
                })),
                parameters: (operation.parameters || []).map((param) =>
                    typeof param.$ref === 'string'
                        ? param.$ref.replace('#/components/parameters/', '')
                        : '' 
                ),
                requestBody: operation.requestBody?.$ref
                    ? operation.requestBody.$ref.replace('#/components/requestBodies/', '')
                    : null, 
            };
            return { ...sanitizedOperation, verb };
        });

        setCurrentPath({ name: pathName, operations: sanitizedOperations });
        setIsFormVisible(true);
    };

    const handleDeletePath = (pathName) => {
        removePath(pathName); 
        if (currentPath?.name === pathName) {
            setIsFormVisible(false); 
            setCurrentPath(null); 
        }
    };

    const handleSavePath = (pathName, operations) => {
        if (currentPath) {
            editPath(pathName, operations); 
        } else {
            addPath(pathName, operations); 
        }
        setIsFormVisible(false); 
        setCurrentPath(null); 
    };

    const handleCancelPath = () => {
        setIsFormVisible(false); 
        setCurrentPath(null); 
    };

    return (
        <div className="paths-container">
            <h3 className={styles.centeredHeading}>Paths</h3>
            {Object.keys(paths).map((pathName) => (
                <div
                    key={pathName}
                    className={styles.style2}
                >
                    {isFormVisible && currentPath?.name === pathName ? (
                        <PathsForm
                            initialData={currentPath}
                            onSave={handleSavePath}
                            onCancel={handleCancelPath}
                            existingTags={existingTags}
                            existingParameters={existingParameters}
                            existingResponses={existingResponses}
                            existingRequestBody={existingRequestBody}
                            existingSecuritySchemes={existingSecuritySchemes}
                            paths={paths}
                        />
                    ) : (
                        <>
                            <h3>Path: {pathName}</h3>
                            
                            {Object.entries(paths[pathName]).map(([verb, operation], index) => (
                                <div
                                    key={index}
                                    className={styles.style6}
                                >
                                    <div>
                                        <strong>{verb.toUpperCase()}</strong>
                                        <p>{operation.summary || 'No summary provided'}</p>
                                    </div>
                                </div>
                            ))}
                            <div style={{
                                display: 'flex',
                                gap: '10px',
                                marginBottom: '10px',
                                justifyContent: 'flex-end',
                            }}>
                                <button
                                    onClick={() => handleEditPath(pathName)}
                                    className={styles.editButton}
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDeletePath(pathName)}
                                    className={styles.deleteButton}
                                >
                                    Delete
                                </button>
                            </div>
                        </>
                    )}
                </div>
            ))}

            {!isFormVisible && (
                <button
                    onClick={handleAddPath}
                    className={styles.addNewButton}
                >
                    + Add Path
                </button>
            )}

            {isFormVisible && !currentPath && (
                <PathsForm
                    initialData={null} 
                    onSave={handleSavePath}
                    onCancel={handleCancelPath}
                    existingTags={existingTags}
                    existingParameters={existingParameters}
                    existingResponses={existingResponses}
                    existingRequestBody={existingRequestBody}
                    existingSecuritySchemes={existingSecuritySchemes}
                    paths={paths}
                />
            )}
        </div>
    );
};

export default PathsSection;
